var Address = /** @class */ (function () {
    function Address(address) {
        this.addressId = address && address.addressId ? address.addressId : '{00000000-0000-0000-0000-000000000000}';
        this.addressKey = address && address.addressKey ? address.addressKey : 0;
        this.addressType = address && address.addressType ? address.addressType : 1;
        this.city = address && address.city ? address.city : '';
        this.countryCode = address && address.countryCode ? address.countryCode : 'US';
        this.countryName = address && address.countryName ? address.countryName : 'United States';
        this.firstName = address && address.firstName ? address.firstName : '';
        this.isDefault = address && address.isDefault ? address.isDefault : false;
        this.isDropShip = address && address.isDropShip ? address.isDropShip : false;
        this.lastName = address && address.lastName ? address.lastName : '';
        this.line1 = address && address.line1 ? address.line1 : '';
        this.line2 = address && address.line2 ? address.line2 : '';
        this.phoneNumber = address && address.phoneNumber ? address.phoneNumber : '';
        this.phoneNumberExt = address && address.phoneNumberExt ? address.phoneNumberExt : null;
        this.postalCode = address && address.postalCode ? address.postalCode : '';
        this.recipientName = address && address.recipientName ? address.recipientName : '';
        this.regionCode = address && address.regionCode ? address.regionCode : '';
        this.regionName = address && address.regionName ? address.regionName : '';
        this.warehouseKey = address && address.warehouseKey ? address.warehouseKey : 5;
        this.isAddressValidationOptOut = address && address.isAddressValidationOptOut ? address.isAddressValidationOptOut : false;
    }
    Object.defineProperty(Address.prototype, "addressClass", {
        get: function () {
            return this.isDropShip ? Address.addressTypes.PATIENT : Address.addressTypes.BUSINESS;
        },
        set: function (type) {
            this.isDropShip = type == Address.addressTypes.PATIENT;
        },
        enumerable: false,
        configurable: true
    });
    return Address;
}());
export default Address;
Address.addressTypes = Object.freeze({
    PATIENT: Symbol('Patient'),
    BUSINESS: Symbol('Business')
});
//# sourceMappingURL=Address.js.map